import { Box, Checkbox, Typography } from "@mui/material";
import type { MouseEvent } from "react";
import type { StudioPolicy } from "../services/api/access";
import designTokens from "../styles/designTokens";

interface StudioPolicyConsentProps {
  checked: boolean;
  id: string;
  onChange: (checked: boolean) => void;
  policy: StudioPolicy;
}

const keepCheckboxState = (event: MouseEvent<HTMLAnchorElement>): void => {
  event.stopPropagation();
};

const StudioPolicyConsent = ({
  checked,
  id,
  onChange,
  policy,
}: StudioPolicyConsentProps) => (
  <Box
    component="label"
    htmlFor={id}
    sx={{
      width: "100%",
      display: "flex",
      alignItems: "flex-start",
      gap: 1,
      cursor: "pointer",
      textAlign: "left",
    }}
  >
    <Checkbox
      id={id}
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
      sx={{
        width: 24,
        height: 24,
        p: 0,
        flexShrink: 0,
        color: designTokens.fill.text.grey60.dark,
        "&.Mui-checked": { color: designTokens.fill.icon.primary50.dark },
      }}
    />
    <Typography
      component="span"
      sx={{
        color: designTokens.fill.text.grey90.dark,
        fontFamily: designTokens.typography.fontFamily.roboto,
        fontSize: 17,
        fontWeight: 400,
        lineHeight: "24px",
      }}
    >
      I agree to the{" "}
      <Box
        component="a"
        href={policy.termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={keepCheckboxState}
        sx={{ color: "inherit", textDecoration: "underline" }}
      >
        Terms of Service
      </Box>{" "}
      and{" "}
      <Box
        component="a"
        href={policy.privacyUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={keepCheckboxState}
        sx={{ color: "inherit", textDecoration: "underline" }}
      >
        Privacy Policy
      </Box>
      .
    </Typography>
  </Box>
);

export default StudioPolicyConsent;
